// react-bootstrap
import ToastContainer from "react-bootstrap/ToastContainer";
import Toast from "react-bootstrap/Toast";
import companyData from "../../companyData";

const ToastInfo = ({ msg, show, onDismissToast }) => {
  return (
    <ToastContainer
      className="p-3"
      containerPosition="fixed"
      position="top-center"
    >
      <Toast
        bg="dark"
        onClose={onDismissToast}
        show={show}
        delay={6000}
        autohide
      >
        <Toast.Header className="justify-content-center align-items-center text-center bg-white">
          <strong className="me-auto">{companyData.name}</strong>
        </Toast.Header>
        <Toast.Body className="text-white">{msg}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ToastInfo;
